import { featureToggleSelector } from './featureToggleSelector';
import { IState } from '../../store';

export const selectMortgageMiniCalculatorSecondaryEnabled = (state: IState) => {
  return featureToggleSelector(state).isMortgageCalculatorInSecondaryObjectCardEnabled;
};
